import { lazy } from 'react'

import { authRoles } from '../../../../auth/authRoles'
import { impresoraRoutesMap } from './impresoraRoutesMap.ts'
import type { ImpresionDocumentoProps } from './interfaces/impresora.ts'

const ImpresoraGestion = lazy(() => import('./view/ImpresoraGestion'))
const ImpresoraAsignacionGestion = lazy(() => import('./view/asignacion/ImpresoraAsignacionGestion'))

export { impresoraRoutesMap }

export interface ImpresoraRoutesOptions {
  /**
   * Documentos que el comercio puede asignar en "Impresoras por Documento", en ese orden.
   * Sin indicar, todos (factura, nota de venta, pedido, estado de cuenta, comanda, cotización, caja...).
   */
  documentos?: readonly ImpresionDocumentoProps[]
}

/**
 * Rutas reutilizables: gestión de impresoras de la sucursal y asignación por documento.
 * Agregar al router del proyecto: `[...crearImpresoraRoutes({ documentos }), ...rutasPropias]`.
 * @example
 * // Comercio sin restaurante
 * crearImpresoraRoutes({
 *   documentos: [IMPRESION_DOCUMENTO.FACTURA, IMPRESION_DOCUMENTO.COTIZACION, IMPRESION_DOCUMENTO.CAJA],
 * })
 */
export const crearImpresoraRoutes = ({ documentos }: ImpresoraRoutesOptions = {}) => [
  {
    path: impresoraRoutesMap.gestion.path,
    element: <ImpresoraGestion />,
    auth: authRoles.admin,
  },
  {
    path: impresoraRoutesMap.documentos.path,
    element: <ImpresoraAsignacionGestion documentos={documentos} />,
    auth: authRoles.admin,
  },
]

/** Rutas con todos los documentos */
const impresoraRoutes = crearImpresoraRoutes()

export default impresoraRoutes
